const appContent = {
  errorMessage: 'Something went wrong'
}

export default appContent